import { withInstall } from '@vuesax-plus/utils'
import Pagination from './src/pagination.vue'

export const VsPagination = withInstall(Pagination)
export default VsPagination

export * from './src/pagination'
